<syslink-grid
  #grid
  [canView]="canView"
  [canSearch]="canSearch"
  [canRefresh]="canRefresh"
  [canAdd]="canAdd"
  [canSort]="canSort"
  [canFilter]="canFilter"
  [canExport]="canExport"
  [canDblClck]="canDblClck"
  [canDelete]="canDelete"
  [canUpdate]="canUpdate"
  [store]="tasksService.store"
  [expand]="tasksService.defaultOptions.expand"
  [select]="select"
  [filter]="filter"
  [columns]="columns"
  (add)="add.emit()"
  [detailsUrl]="detailsUrl"
  [storageKey]="storageKey"
  (doubleClick)="rowDoubleClicked.emit($event)"
  [toolbaActions]="toolbarActions"
  [contextMenuItems]="contextMenuItems"
  (refresh)="refresh()"
></syslink-grid>